import { render, staticRenderFns } from "./sub-navigation.vue?vue&type=template&id=81c7eed6&"
import script from "./sub-navigation.vue?vue&type=script&lang=js&"
export * from "./sub-navigation.vue?vue&type=script&lang=js&"
import style0 from "./sub-navigation.vue?vue&type=style&index=0&id=81c7eed6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports